<template>
  <article class="debt-item">
    <div class="debt-item__info">
      <profile-image
        :src="user.avatar_url"
        :user="user"
        class="debt-item__image"
        width="34px"
        height="34px"/>
      <div class="debt-item__username">{{ $getUserName(user) }}</div>
    </div>
    <div :class="{ 'debt-item__controls': !eventIsOriginal }">
      <money-message
        :type="type"
        :currency="user.currency || currency"
        :money-amount="moneyAmount"
      />
      <button
        v-if="!eventIsOriginal"
        class="debt-item__create"
        @click="addPayout"
      >
        {{ $t('CP.create') }}
      </button>
    </div>
  </article>
</template>

<script>
import { SET_OPERATION, SET_PAYBACK_INFO } from '@/store/operations/types';
import ProfileImage from '../ProfileImage/ProfileImage';
import MoneyMessage from '../MoneyMessagge/MoneyMessage';

export default {
  name: 'DebtItem',
  components: {
    MoneyMessage,
    ProfileImage,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    moneyAmount: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      validator(val) {
        return ['accrual', 'debit'].includes(val);
      },
      default: 'accrual',
    },
    eventIsOriginal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addPayout() {
      this.$store.commit(SET_OPERATION, 'payback');
      this.$store.commit(SET_PAYBACK_INFO, {
        type: this.type,
        money: this.moneyAmount,
        user: this.user,
        currency: this.user.currency || this.currency,
      });
      this.$bvModal.show('add-transaction');
    },
  },
};
</script>

<style lang="scss" scoped>
 .debt-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  margin: 6px auto;
  border-radius: 6px;
  border: 1px solid #E6ECF8;
  min-height: 46px;
 }

 .debt-item__info {
  display: flex;
  flex: 5;
  align-items: center;
  justify-content: flex-start;
 }

 .debt-item__controls {
   display: flex;
   flex: 3;
   align-items: center;
   justify-content: flex-end;
 }

 .debt-item__image {
   margin-right: 12px;
 }

 .debt-item__money {
   margin-right: 23px;
 }

 .debt-item__create {
   border: none;
   background: none;
   color: var(--btn-primary);
   font-size: 13px;
   padding: 10px 14px;
   outline: none;
 }

 .debt-item__create:hover {
    color: var(--text-main-color);
 }

</style>
